import React from 'react';
import { Navigate } from 'react-router-dom';
import { ComplexRoute } from 'router/components/Routes/Routes';
import SchoolGroupResidentialType from '../../pages/SchoolGroupResidentialType';
import PublicSchoolSubtypeForm from '../../pages/PublicSchoolSubtypeForm';

export default [
  {
    path: 'residential-type/:residentialType',
    element: PublicSchoolSubtypeForm,
  },
  {
    path: 'residential-type',
    element: SchoolGroupResidentialType,
  },
  {
    index: true,
    element: <Navigate to="residential-type" replace />,
  },
] as Array<ComplexRoute>;
